import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { automationQueryKeys } from "./automationQueryKeys";

export function useAutomationEnable({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (automationId: number) => {
      await api.automationApi.active(automationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: automationQueryKeys.all() });
    },
  });
}
